import * as React from 'react';
import { TrackingProvider } from './tracking-context.js';
import { useTracking } from './use-tracking.js';

function ModalTracker({
  name,
  isOpen,
  children,
  trackingData
}) {
  const rootTrack = useTracking();
  const properties = {
    modal: name,
    ...trackingData
  };
  const previousIsOpen = React.useRef(isOpen);
  React.useEffect(() => {
    function track() {
      rootTrack('modal_view', properties);
    }
    if (previousIsOpen.current === false && isOpen === true) {
      track();
    }
    previousIsOpen.current = isOpen;
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(TrackingProvider, {
    value: properties
  }, children);
}

export { ModalTracker };
